import React from 'react';

import CustomNavbar from '../components/CustomNavbar';

import HeroSection from '../components/HeroSection';

import ProductSection from '../components/ProductSection';

import SuggestedSection from '../components/SuggestedSection';

function HomePage() {
  return (
    <>
      <CustomNavbar />

      <HeroSection />

      <ProductSection />

      {/* Personalised picks sit below Top Sale: the store's own promotion
          leads, then suggestions drawn from what this visitor dwelled on. */}
      <SuggestedSection />
    </>
  );
}

export default HomePage;
